import { ReactElement } from 'react';

const YoutubeIcon = (props: TClassNameProps): ReactElement => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.79 5.421a2.51 2.51 0 0 1 1.766 1.777c.61 2.471.57 7.144.013 9.654a2.51 2.51 0 0 1-1.767 1.776c-2.432.605-13.326.53-15.618 0a2.51 2.51 0 0 1-1.766-1.776c-.575-2.356-.535-7.337-.013-9.641a2.51 2.51 0 0 1 1.767-1.777c3.251-.682 14.46-.462 15.617-.013zm-9.73 3.592 5.223 3.012-5.223 3.012V9.013z"
			fill="currentColor"
		/>
	</svg>
);

export default YoutubeIcon;
